import React from "react";
import { Layout, Typography, Row } from "antd";
import Top from "../../components/common/Top";
import { PAGE_COMPANY, PAGE_NAME } from "../../config";
import "./index.scss";
import about_us_bg from "../../assets/images/about_us(1).png";
import descIcon from "../../assets/images/company_desc.png";
import comLogo from "../../assets/images/company_logo.png";
import aimIcon from "../../assets/images/company_aim.png";
import structureIcon from "../../assets/images/company_struc.png";
import structureDetail from "../../assets/images/structure-company.png";
import telIcon from "../../assets/images/company_tel.png";
import massesIcon from "../../assets/images/masses(1).png";
import teamIcon from "../../assets/images/team.png";
import flagIcon from "../../assets/images/flag.png";
import Footer from "../../components/common/Footer";

const { Title } = Typography;

const AboutUs = () => {
  const goDetail = (path) => {
    document.querySelector("#" + path).scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  return (
    <Layout
      style={{ minHeight: "100%", minWidth: "100%" }}
      className="about-us"
    >
      <Top />

      <Layout>
        <div className="top">
          <div className="top-content">
            <div>
              <div className="col-lg-2"></div>
              <div className="col-lg-8">
                <div className="content">
                  <Title level={1} style={{ marginBottom: "0" }}>
                    关于我们
                  </Title>
                  <Title level={2}>{PAGE_COMPANY}</Title>
                </div>
              </div>
              <div className="col-lg-2"></div>
            </div>
            <div className="bottom-nav">
              <div className="col-lg-2"></div>
              <div className="col-lg-8">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    className="nav-item"
                    onClick={() => goDetail("description")}
                  >
                    公司简介
                  </div>
                  <div className="nav-item" onClick={() => goDetail("aim")}>
                    企业规划
                  </div>
                  <div
                    className="nav-item"
                    onClick={() => goDetail("structure")}
                  >
                    组织架构
                  </div>
                  <div className="nav-item" onClick={() => goDetail("tele")}>
                    联系方式
                  </div>
                  <div className="nav-item" onClick={() => goDetail("masses")}>
                    党群建设
                  </div>
                </div>
              </div>
              <div className="col-lg-2"></div>
            </div>
          </div>
        </div>

        <Row className="nav-content">
          <div className="col-lg-2"></div>
          <div className="col-lg-8">
            <Row className="qualification" align="middle">
              <div className="nav-content-item" id="description">
                <div className="content-item-title">
                  <img
                    src={descIcon}
                    alt=""
                    width={30}
                    style={{ marginRight: 30 }}
                  />
                  公司简介
                </div>
                <div style={{ display: "flex" }}>
                  <div className="company-desc">
                    <p>
                      上海宝山保障性住房有限公司（以下简称：公司）成立于2011年6月，于2015年8月完成重组，当前注册资本为43.31亿元。
                    </p>
                    <p>
                      公司主营业务为公共租赁住房投资、经营、建设；物业管理；住房租赁；非居住房地产租赁；停车场（库）经营。目前共设综合管理部、租赁市场部、客户服务部、业务发展部、工程管理部、经营财务部等6个职能部门。
                    </p>
                    <p>
                      公司主要服务于我区经济发展、人才引进以及阶段性住房保障困难群体。
                    </p>
                  </div>
                  <div
                    className="company-desc-logo"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "end",
                    }}
                  >
                    <img src={comLogo} alt="" style={{ width: '192px', height: '179px' }} />
                  </div>
                </div>
              </div>
              <div className="nav-content-item" id="aim">
                <div className="content-item-title">
                  <img
                    src={aimIcon}
                    alt=""
                    width={30}
                    style={{ marginRight: 30 }}
                  />
                  企业规划
                </div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    margin: "20px 0",
                  }}
                >
                  <div className="aim-item purpose">
                    <div className="aim-item-title">
                      <div>企业宗旨</div>
                      <div className="aim-item-detail">
                        <div>保障供给、盘活存量</div>
                        <div>优化资源、服务民生</div>
                      </div>
                    </div>
                  </div>

                  <div className="aim-item idea">
                    <div className="aim-item-title">
                      <div>发展理念</div>
                      <div className="aim-item-detail ">
                        <div className="aim-item-detail-item">
                          · <div>平衡发展：优化房源布局。</div>
                        </div>
                        <div className="aim-item-detail-item">
                          ·
                          <div>
                            共享发展：服务宝山 “两区一体化” 建设，强化住房保障。
                          </div>
                        </div>
                        <div className="aim-item-detail-item">
                          ·<div>普惠性发展：严审准入，应保尽保，住有所居。</div>
                        </div>
                        <div className="aim-item-detail-item">
                          ·
                          <div>
                            可持续发展：梳理流程、总结经验，形成可复制模式，高质量发展。
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="aim-item spirit">
                    <div className="aim-item-title">
                      <div>团队精神</div>
                      <div className="aim-item-detail">
                        <div>目标一致、团结合作、诚信互助、 </div>
                        <div>向上向善、携手共进、协作共赢发展。</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="nav-content-item" id="structure">
                <div className="content-item-title">
                  <img
                    src={structureIcon}
                    alt=""
                    width={30}
                    style={{ marginRight: 30 }}
                  />
                  组织架构
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: 20,
                  }}
                >
                  <img
                    src={structureDetail}
                    alt=""
                    style={{ width: "50vw", maxWidth: 662 }}
                  />
                </div>
              </div>
              <div className="nav-content-item tele" id="tele">
                <div className="tele-bg">
                  <div className="content-item-title">
                    <img
                      src={telIcon}
                      alt=""
                      width={30}
                      style={{ marginRight: 30 }}
                    />
                    联系方式
                  </div>
                  <div className="tele-detail">
                    <div>地址：宝山区盘古路572号1号楼4楼</div>
                    <div>咨询电话：021-56100661或021-56671727</div>
                    <div>微信公众号：bgzfgs</div>
                    <div>
                      办公时间：周一至周五上午8：30~11:30下午13：00~17:00
                    </div>
                    <div>
                      周边交通：地铁3号线友谊路站、盘古路樟岭路站（宝山10路、宝山23路、宝山2路）等公交线路
                    </div>
                  </div>
                </div>
              </div>
              <div className="nav-content-item" id="masses">
                <div className="content-item-title">
                  <img
                    src={massesIcon}
                    alt=""
                    width={30}
                    style={{ marginRight: 30 }}
                  />
                  党群建设
                </div>
                <div style={{ padding: 30 }}>
                  <div className="masses-title">
                    公司党支部以实现全面深化服务型党组织建设为主要目标，全面提高工作效能，不断提升基层党建工作水平，确保公司全年各项工作落实到位，为公司科学发展提供坚强的组织保证。
                  </div>
                  <div style={{ marginTop: 20 }} className="team-flag">
                    <div className="team">
                      <div className="team-title">
                        <img
                          src={teamIcon}
                          alt=""
                          style={{ marginRight: 10 }}
                        />
                        队伍建设
                      </div>
                      <div className="team-content">
                        围绕公司行政工作勇于实践、敢于创新、善于督查，不断增强党的创造力、凝聚力、战斗力。
                      </div>
                    </div>
                    <div style={{ marginLeft: 20 }} className="team flag">
                      <div className="team-title">
                        <img
                          src={flagIcon}
                          alt=""
                          style={{ marginRight: 10 }}
                        />
                        作风建设
                      </div>
                      <div className="team-content">
                        落实党风廉政建设主体责任和监督责任，严格权力运行制约和监督，构建不敢腐、不能腐、不想腐的有效机制。
                      </div>
                    </div>
                  </div>
                  <div className="work">
                    <div className="work-bg">
                      <div className="work-title">工作做法</div>
                      <div style={{ display: "flex" }}>
                        <div style={{ flex: 2 }} className="work-item">
                          <div className="work-item-line">
                            1. <div>落实 “三重一大” 党支部扩大会议决策机制</div>
                          </div>
                          <div className="work-item-line">
                            2.
                            <div>
                              规范 “三会一课”，践行
                              “五个一”（日巡查、周谈话、月学习、季活动、年发展），党建带团建协同推进保租房工作。
                            </div>
                          </div>
                          <div className="work-item-line">
                            3. <div>实施月度目标考核。</div>
                          </div>
                          <div className="work-item-line">
                            4.
                            <div>
                              推行 “四位一体” 教育模式，制定年度菜单式培训计划。
                            </div>
                          </div>
                          <div className="work-item-line">
                            5. <div> 建职工之家，在解决问题中推进工作。</div>
                          </div>
                        </div>
                        <div
                          className="work-item-null"
                          style={{ flex: 1 }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          </div>
          <div className="col-lg-2"></div>
        </Row>
      </Layout>
      <Footer />
    </Layout>
  );
};

export default AboutUs;
